// Dashboard Types
import { WeeklySessionData } from '../../interaxDesignSystemComponents/SessionItem'
import { SprintTeamDetail } from '../../types/TrainingSprintTypes'

export type { SprintTeamDetail }

// Dashboard Action Box Type Enum
export enum DashboardActionBoxType {
  SETUP_TRAINING_SPRINT = 'setup-training-sprint',
  GENERATE_REPORTS = 'generate-reports',
  DOWNLOAD_INTRODUCTION_MATERIAL = 'download-introduction-material',
  JOIN_TRAINING_SPRINT = 'join-training-sprint',
  VIEW_PROGRESS = 'view-progress',
  DOWNLOAD_MATERIALS = 'download-materials'
}

// Dashboard Info Box Types
export interface DashboardInfoBox {
  title: string
  value: string | number
  change?: string
  changeType?: 'increase' | 'decrease' | 'neutral'
  status?: string
  statusType?: 'live' | 'active' | 'inactive'
  changeData?: Record<string, string | number> // For i18n interpolation variables
}

// Dashboard Action Box Types
export interface DashboardActionBox {
  type: DashboardActionBoxType
  title: string
  description: string
  buttonText: string
}

// Session Item Types - using the existing SessionRight type from design system
export interface DashboardSessionItem {
  id: string
  title: string
  meta?: {
    time?: string
    date?: string
    team?: string
  }
  right?:
    | {
        type: 'pill'
        pill: { status: 'active' | 'upcoming' | 'draft' | 'completed' | 'live'; label?: string }
      }
    | {
        type: 'button'
        label: string
        onClick: () => void
      }
    | {
        type: 'none'
      }
}

// Sprint Card Types
export interface DashboardSprintCard {
  id: string
  status: 'active' | 'upcoming' | 'draft' | 'completed' | 'live'
  title: string
  details: Array<{ label: string; value: string | number }>
  progress?: number
  teamDetails?: SprintTeamDetail[]
  unassignedMemberNames?: string[]
}

// Facilitator Dashboard Data
export interface FacilitatorDashboardData {
  // Action boxes (3 boxes)
  actionBoxes: DashboardActionBox[]

  // Info boxes (4 boxes)
  infoBoxes: DashboardInfoBox[]

  // This week's sessions
  thisWeekSessions: WeeklySessionData[]

  // Active sprints
  activeSprints: DashboardSprintCard[]
}

// Gamer Dashboard Data
export interface GamerDashboardData {
  // Similar structure but for gamer perspective
  actionBoxes: DashboardActionBox[]
  infoBoxes: DashboardInfoBox[]
  upcomingSessions: WeeklySessionData[]
  mySprints: DashboardSprintCard[]
}
